import { FunctionComponent } from 'react'
import {
  TableCell,
  TableRow,
  Typography,
  rucksack,
} from '@black-bear-energy/rucksack'

interface DocumentRequirementPlaceholderRowProps {
  depth: number
}

export const DocumentRequirementPlaceholderRow: FunctionComponent<
  DocumentRequirementPlaceholderRowProps
> = ({ depth }) => {
  return (
    <TableRow>
      <TableCell>
        <Typography
          variant="body2"
          sx={{
            color: rucksack.palette.text.secondary,
            marginLeft: `${depth * 16}px`,
            fontStyle: 'italic',
          }}
        >
          No Uploads
        </Typography>
      </TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
    </TableRow>
  )
}

DocumentRequirementPlaceholderRow.displayName =
  'DocumentRequirementPlaceholderRow'
